import React from 'react';

import PageHero from '../../MyComponents/LandingSections/PageHero';
import FeatureCards from '../../MyComponents/LandingSections/FeatureCards';
import StepsCard from '../../MyComponents/LandingSections/StepsCard';
import HomeWhy from '../Home/HomeWhy/HomeWhy';
import HomePricing from '../Home/HomePricing/HomePricing';
import HomeFaq from '../Home/HomeFaq/HomeFaq';
import HomeContact from '../Home/HomeContact/HomeContact';
import { featureLinks } from '../../common/features';
import { START_FREE_LINK, SUBSCRIPTIONS_LINK, tutorialLinks } from '../../common/urlLinks';
import { REDESIGN_TINTS } from '../../constants';

// The before/after pair for tutoring: the tutor's session, then the student's.
const WHY_CARDS = [
    { key: 'tutor', dark: false, bullets: 4 },
    { key: 'student', dark: true, bullets: 3 },
];

// The three things the old page listed, each with its illustration. `more`
// goes to the tutorial that walks through it.
// Their images are generated scenes with the app keyed onto the screens, in the
// visitor's language, so `src` is set in the component.
const FEATURES = [
    {
        key: 'levels',
        src: null,
        tint: REDESIGN_TINTS.mint,
        mediaFirst: true,
        more: tutorialLinks.individualBoards,
        fit: 'cover',
    },
    {
        key: 'save',
        src: null,
        tint: REDESIGN_TINTS.amber,
        mediaFirst: false,
        more: tutorialLinks.saveIndividualBoards,
        fit: 'cover',
    },
    {
        key: 'call',
        src: null,
        tint: REDESIGN_TINTS.sky,
        mediaFirst: true,
        more: tutorialLinks.audioVideo,
        fit: 'cover',
    },
];

// The five steps of a session, as the old page listed them.
const STEPS = [
    { key: 'group', more: tutorialLinks.groups },
    { key: 'call', more: tutorialLinks.audioVideo },
    { key: 'boards', more: tutorialLinks.individualBoards },
    { key: 'library', more: tutorialLinks.library },
    { key: 'download', more: featureLinks.pdfDownload },
];

/**
 * The tutoring page, composed from the landing's section primitives. The hero
 * leads with the real individual-boards screenshot; pricing is the landing's
 * plan section, since tutors buy a plan for themselves.
 */
const ForTutoring = ({ language }) => {
    const features = FEATURES.map((feature) => ({
        ...feature,
        src: `/redesign/tutoring-${feature.key}.${language}.webp`,
    }));

    return (
        <>
            <PageHero
                keyPrefix="redesign.tutoring.hero"
                primaryTo={START_FREE_LINK}
                secondaryTo={SUBSCRIPTIONS_LINK}
                trust={['call', 'boards', 'freePlan']}
                image={{ src: `/redesign/tutoring-hero.${language}.webp`, width: 800, height: 450 }}
            />
            <HomeWhy id="de-ce" keyPrefix="redesign.tutoring.why" cards={WHY_CARDS} />
            <FeatureCards id="functii" keyPrefix="redesign.tutoring.features" features={features} />
            <StepsCard id="cum-incepe" keyPrefix="redesign.tutoring.steps" steps={STEPS} />
            <HomePricing />
            <HomeFaq keyPrefix="redesign.tutoring.faq" count={5} />
            <HomeContact keyPrefix="redesign.tutoring.contact" to={START_FREE_LINK} />
        </>
    );
};

export default ForTutoring;
